import { AppPageFrame } from "@interface48/app";
import Button from "@material-ui/core/Button";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { QuizzesTable } from "../../../components/quizzes";
import { actionCreators, AdministrationActions, AdministrationState, ApplicationState } from "../../../store";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      margin: theme.spacing(2),
    },
    button: {
      marginLeft: "auto",
      marginBottom: theme.spacing(2),
    },
  });

interface QuizzesIndexPageStateProps {
  administrationState: AdministrationState;
}

interface QuizzesIndexPageDispatchProps {
  administrationActions: AdministrationActions;
}

interface QuizzesIndexPageOwnProps extends RouteComponentProps<any>, WithStyles<typeof styles> {}

type QuizzesIndexPageProps = QuizzesIndexPageStateProps & QuizzesIndexPageDispatchProps & QuizzesIndexPageOwnProps;

const QuizzesIndexPageComponent = class extends React.Component<QuizzesIndexPageProps> {
  public componentDidMount() {
    const { administrationActions } = this.props;

    administrationActions.requestQuizzes();
  }

  public render() {
    const { administrationState, classes } = this.props;
    const { quizzes, actionStatus } = administrationState;

    const windowWidth = window.innerWidth;
    const isTableLoading =
      actionStatus && actionStatus.type === "ADMINISTRATION_QUIZZES_REQUEST" && actionStatus.pending;

    return (
      <AppPageFrame pageTitle="Quizzes" fullWidth={true} onBackClick={this.handleBackClick}>
        <div className={classes.root}>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            component={Link}
            to="/administration/quizzes/add"
          >
            Add Quiz
          </Button>
          <QuizzesTable results={quizzes ?? []} width={windowWidth} isLoading={isTableLoading} />
        </div>
      </AppPageFrame>
    );
  }

  private handleBackClick = () => {
    this.props.history.push("/administration");
  };
};

export const QuizzesIndexPage = withStyles(styles)(
  connect<QuizzesIndexPageStateProps, QuizzesIndexPageDispatchProps, QuizzesIndexPageOwnProps, ApplicationState>(
    (state) => ({
      administrationState: state.administration,
    }),
    (dispatch) => ({
      administrationActions: bindActionCreators(actionCreators.administration, dispatch),
    }),
  )(QuizzesIndexPageComponent),
);
